import { useState, useEffect } from "react";
import { FormRow, Alert } from "../../components";
import { displayAlert, registerUser, loginUser } from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components";
import "./styles.css";

const initialState = {
  username: "",
  email: "",
  password: "",
  isMember: true,
};

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.registeredUser.user);
  const isLoading = useSelector((state) => state.registeredUser.isLoading);
  const showAlert = useSelector((state) => state.registeredUser.showAlert);
  const [values, setValues] = useState(initialState);

  const toggleMember = () => {
    setValues({ ...values, isMember: !values.isMember });
  };

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { username, email, password, isMember } = values;
    if (!email || !password || (!isMember && !username)) {
      dispatch(displayAlert());
      setTimeout(() => {
        dispatch({
          type: "CLEAR_ALERT",
        });
      }, 2000);
      return;
    }
    const currentUser = { username, email, password };
    if (isMember) {
      dispatch(loginUser(currentUser));
    } else {
      dispatch(registerUser(currentUser));
    }
  };

  useEffect(() => {
    if (user) {
      setTimeout(() => {
        navigate("/profile");
      }, 2000);
    }
  }, [user, navigate]);
  return (
    <div className="registerContainer">
      <div className="registerWrapper">
        <form onSubmit={handleSubmit} className="form">
            <h3>{values.isMember ? "Login" : "Register"}</h3>
            {showAlert && <Alert />}
            <div className="align">
            {/* username input */}
            {!values.isMember && (
              <FormRow
                type="text"
                name="username"
                value={values.username}
                htmlFor="username"
                handleChange={handleChange}
              />
            )}
            {/* email input */}
            <FormRow
              type="email"
              name="email"
              value={values.email}
              htmlFor="email"
              handleChange={handleChange}
            />
            {/* password input */}
            <FormRow
              type="password"
              name="password"
              value={values.password}
              htmlFor="password"
              handleChange={handleChange}
            />
          </div>
          <Button
            disabled={isLoading}
            type="submit"
            text={
              <>
                Submit<span aria-hidden></span>
                <span aria-hidden class="cybrBtnGlitch">
                  Submit
                </span>
              </>
            }
          />
        </form>
      </div>
      <div>
        <h2 className="text">
          {values.isMember ? "Not a member yet ?" : "Already a member ?"}
          <Button
            type="button"
            onClick={toggleMember}
            text={
              values.isMember ? (
                <>
                  Register<span aria-hidden></span>
                  <span aria-hidden class="cybrBtnGlitch">
                    Register
                  </span>
                </>
              ) : (
                <>
                  Login<span aria-hidden></span>
                  <span aria-hidden class="cybrBtnGlitch">
                    Login
                  </span>
                </>
              )
            }
          />
        </h2>
      </div>
    </div>
  );
};

export default Register;
